import {Component} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {SettingsEmailMerge} from '../../../types/data.types';
import {DirectoryService} from '../../../services/directory.service';
import {SettingsEmailMergeService} from '../../../services/settings-email-merge.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'settings-email-merge-detailed-view',
    templateUrl: './settings-email-merge-detailed-view.component.html',
    styleUrls: ['./settings-email-merge-detailed-view.component.scss']
})

export class SettingsEmailMergeDetailedViewComponent {
    data: SettingsEmailMerge;
    navPosition = 'tab_settings';
    isFromEditMode = false;
    disabledSenderSubmit = false;
    noEdit = false;

    constructor(public api: ApiClientService,
                public settingsEmailMergeService: SettingsEmailMergeService,
                public directoryService: DirectoryService) {
    }

    onSubmit(data: any): void {
        this.noEdit = true;
        const url = `/api/v1/corporation_number_service_settings/${this.settingsEmailMergeService.selectedItemData.corporationNumberId}.json`;
        this.settingsEmailMergeService.api.patch('domainEmails', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false, data),
            () => toastr.error('Update failed!'),
            () => this.noEdit = false
        );
    }

    updateView(msg: string, close = true, data): void {
        if(Object.keys(data).indexOf('emailSender') != -1) {
            this.isFromEditMode = false;
            this.disabledSenderSubmit = false;
            this.settingsEmailMergeService.selectedItemData.emailSender = data.emailSender;
        }
        if (msg) toastr.success(msg);
        this.settingsEmailMergeService.toggleDetailedView(this.settingsEmailMergeService.selectedItemData, true);
        this.settingsEmailMergeService.getSettingsForCorporation(this.settingsEmailMergeService.selectedItemData.corporationNumberId);
        if (close) this.settingsEmailMergeService.toggleDetailedView(null, false);
    }

    setEditModeFor(item, fieldName: string, state: boolean) {
        this.setEditModeForAll(false);
        item.formFields[fieldName].editMode = state;
    }

    setEditModeForAll(state: boolean) {
        for(const field in this.settingsEmailMergeService.selectedItemData.formFields)
            this.settingsEmailMergeService.selectedItemData.formFields[field].editMode = state;
    }

    applyChanges(item, form, changedValue, formField) {
        let valueToSend = changedValue;
        if (changedValue.shareContact === 'true')
            valueToSend.shareContact = 1;
        else if (changedValue.shareContact === 'false')
            valueToSend.shareContact = 0;

        if (changedValue.requestType) {
            if (changedValue.requestType.length == 1 && changedValue.requestType != '0')
                valueToSend = {serviceRequestType: changedValue.requestType};
            else
                valueToSend = {serviceRequestTypeOther: changedValue.requestType};
        }

        if (form.dirty) {
            item[formField] = form.value[formField];
            if (form.valid) this.setEditModeForAll(false);
            this.onSubmit(valueToSend);
        } else {
            this.setEditModeForAll(false);
        }
    }

    showNotificationModal(notificationType): void {
        this.settingsEmailMergeService.showNotificationsModal = true;
        this.settingsEmailMergeService.bookingRequestModalNotificationType = notificationType;
    }

    submitNotificationsField(): void {
        const data = {staffNotificationSettings : [
                {
                    action: 'created',
                    enableStatus: this.settingsEmailMergeService.keyCreatedStaffCheckbox,
                    userRoles: this.getUserRolesFormatted(this.settingsEmailMergeService.createdStaffMultiselectArray)
                },
                {
                    action: 'deleted',
                    enableStatus: this.settingsEmailMergeService.keyDeletedStaffCheckbox,
                    userRoles: this.getUserRolesFormatted(this.settingsEmailMergeService.deletedStaffMultiselectArray)
                },
                {
                    action: 'modified',
                    enableStatus: this.settingsEmailMergeService.keyModifiedStaffCheckbox,
                    userRoles: this.getUserRolesFormatted(this.settingsEmailMergeService.modifiedStaffMultiselectArray)
                },
                {
                    action: 'signed_out',
                    enableStatus: this.settingsEmailMergeService.keySignedOutStaffCheckbox,
                    userRoles: this.getUserRolesFormatted(this.settingsEmailMergeService.signedOutStaffMultiselectArray)
                },
                {
                    action: 'returned',
                    enableStatus: this.settingsEmailMergeService.keyReturnedStaffCheckbox,
                    userRoles: this.getUserRolesFormatted(this.settingsEmailMergeService.returnedStaffMultiselectArray)
                }
            ]
        };
        this.onSubmit(data);
    }

    getUserRolesFormatted(arr): Array<any> {
        return arr.map(a => ({bdId: a.id, roleName: a.itemName}));
    }

    changeNavPosition(changeTo): void {
        this.navPosition = changeTo;
    }

    emailTemplateIsSet(action) {
        let flag = false;
        if(this.settingsEmailMergeService.selectedItemData.staffNotificationSettings) {
            this.settingsEmailMergeService.selectedItemData.staffNotificationSettings.filter((setting) => {
                if (setting.action == action)
                    flag = setting.emailTemplate === null && !setting.emailTemplateOtherMessage && !setting.emailTemplateOtherSubject ? false : true;
            });
        }
        return flag;
    }

    isChangedEmailValid(email) {
        if(!email) {
            this.onSubmit({emailSender: email});
        } else {
            if (!email.match('[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?')) {
                toastr.warning('Email is invalid');
                return;
            }
            const url = `/v1/public/check_sender/${email}`;
            this.api.get('domainNotifications', url).subscribe(
                res => {
                    const body = JSON.parse(res._body);
                    if (body.status != 'Success') {
                        toastr.error('Email is not valid');
                        swal({
                            title: 'Email is not verified',
                            text: 'We will send confirmation email to your inbox. Please click Yes to proceed, or No if you want to change email.',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#DD6B55',
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'No',
                            closeOnConfirm: true
                        }, () => this.sendVerificationEmail(email));
                    } else {
                        this.disabledSenderSubmit = true;
                        this.onSubmit({emailSender: email});
                    }
                },
                error => this.api.errorHandler(error, 'Failed to verify entered email.')
            );
        }
    }

    sendVerificationEmail(email) {
        const url = '/v1/public/add_sender';
        const data = {email: email};
        this.settingsEmailMergeService.api.post('domainNotifications', url, {email: email}).subscribe(
            () => toastr.success('Verification has been sent successfully'),
            (error) => this.api.errorHandler(error, 'Failed to send verification.'),
            () => this.noEdit = false
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-email-merge/settings-email-merge-detailed-view/settings-email-merge-detailed-view.component.ts